import { NewEquipmentRow, EquipmentRowModified } from '@/views/main/license/extend/form/new-record/new-record.interfaces';
import { mustSelectOne } from '@/views/main/license/extend/form/new-record/new-record.validators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { DetailLicenseById } from '@/interfaces/search/search.interface';

type LicenseType = DetailLicenseById['equipments'][0]['licenseTypes'][0];
type Zone = DetailLicenseById['equipments'][0]['conductionZones'][0];

@Component({
  selector: 'app-modify-equipment-form',
  templateUrl: './modify-equipment-form.component.html',
  styleUrls: ['./modify-equipment-form.component.css'],
})
export class ModifyEquipmentFormComponent implements OnInit {
  @Input() emptyTitles: boolean = false;
  @Input() colorInputs: 'GREY' | 'WHITE' = 'GREY';

  @Input() id: number = 0;
  @Input() brand: string = '';
  @Input() model: string = '';

  @Input()
  set licenseTypes(licenseTypes: LicenseType[]) {
    this.setLicenseTypes(licenseTypes);
  }
  get licenseTypes(): LicenseType[] {
    return this._licenseTypes;
  }
  _licenseTypes: LicenseType[] = [];

  @Input()
  set conductionZones(conductionZones: Zone[]) {
    this.setConductionZones(conductionZones);
  }
  get conductionZones(): Zone[] {
    return this._conductionZones;
  }
  _conductionZones: Zone[] = [];

  conductionZonesSlice = 1;

  @Output() modifyEquipment = new EventEmitter<EquipmentRowModified>();
  @Output() discardChanges = new EventEmitter<true>();

  newEquipmentForm: FormGroup = new FormGroup({
    brand: new FormControl(''),
    model: new FormControl(''),
    licenseTypes: new FormArray([], [mustSelectOne()]),
    conductionZones: new FormArray([], [mustSelectOne()]),
  });

  constructor() { }

  ngOnInit(): void {
    this.newEquipmentForm.patchValue({ brand: this.brand, model: this.model });
  }

  getCheckControls(id: number, formType: 'LICENSE_TYPE' | 'ZONES' = 'ZONES') {
    let indexReq = -1;
    const formSectionType = formType === 'LICENSE_TYPE' ?
      this.asFormArray(this.newEquipmentForm.controls.licenseTypes)
      :
      this.asFormArray(this.newEquipmentForm.controls.conductionZones);

    formSectionType.value.some(({ id: rowIndex }: any, formArrayIndex: number) => {
      if (rowIndex === id) {
        indexReq = formArrayIndex;
      }
    });
    const formGroup = formSectionType.at(indexReq) as FormGroup;
    return formGroup.controls;
  }

  onDiscardChanges() {
    this.discardChanges.emit(true);
    this.resetForm();
  }

  asFormControl(control: AbstractControl) {
    return control as FormControl;
  }

  asFormArray(control: AbstractControl) {
    return control as FormArray;
  }

  iAmTheLastOfMyKind(id: number, formType: 'LICENSE_TYPE' | 'ZONES' = 'ZONES') {
    const control = this.asFormControl(this.getCheckControls(id, formType).active);
    const formArray = formType === 'LICENSE_TYPE' ?
      this.asFormArray(this.newEquipmentForm.controls.licenseTypes)
      :
      this.asFormArray(this.newEquipmentForm.controls.conductionZones);
    const activeControls = (formArray.controls as FormControl[]).filter((x) => x.value.active);

    return activeControls.length === 1 && control.value;
  }

  onSaveChanges() {
    const formData = this.newEquipmentForm.value;
    const equipmentModified: EquipmentRowModified = {
      id: this.id,
      brand: formData.brand,
      model: formData.model,
      conductionZones: formData.conductionZones.filter((x:any) => x.active).map((x: any) => x.id),
      licenseTypes: formData.licenseTypes.filter((x:any) => x.active).map((x: any) => x.id),
    };
    this.modifyEquipment.emit(equipmentModified);
  }

  resetForm() {
    this.newEquipmentForm.patchValue({ brand: this.brand, model: this.model });
    this.setLicenseTypes(this.licenseTypes);
    this.setConductionZones(this.conductionZones);
  }
  setLicenseTypes(licenseTypes: LicenseType[]) {
    const formArray = this.newEquipmentForm.controls.licenseTypes as FormArray;

    for (let i = 0; i < formArray.length; i++) {
      formArray.removeAt(i);
    }

    licenseTypes.map((item) => {
      formArray.push(new FormGroup({
        id: new FormControl(item.id),
        name: new FormControl(item.description),
        active: new FormControl(true),
        isEnabled: new FormControl(true),
        isHidden: new FormControl(false),
      }));
    });
    this._licenseTypes = licenseTypes;
  }

  setConductionZones(conductionZones: Zone[]) {
    const formArray = this.newEquipmentForm.controls.conductionZones as FormArray;

    for (let i = 0; i < formArray.length; i++) {
      formArray.removeAt(i);
    }

    conductionZones.filter((item) => {

      const enabled = true;
      const active = true;
      const isHidden = false;

      formArray.push(new FormGroup({
        id: new FormControl(item.id),
        name: new FormControl(item.description),
        active: new FormControl(active),
        isEnabled: new FormControl(enabled),
        isHidden: new FormControl(isHidden),
      }));
    });

    this.conductionZonesSlice = Math.ceil(conductionZones.length / 2);
    this._conductionZones = conductionZones;
  }
}
